<template>
<!-- eslint-disable max-len -->
<list-page
  name="Major Decision"
  use="_id"
  :display="display"
  page-prefix="/blade/major-decisions"
  :fetch="getData"
  :remove="deleteTeamDecision"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  data() {
    return {
      individualDecisionsById: {},
      teamDecisionsById: {}
    };
  },
  methods: {
    ...mapActions([
      'getTeamDecisions',
      'getIndividualDecisions',
      'deleteTeamDecision',
    ]),
    async getData() {
      const [teamDecisions, individualDecisions] =
        await Promise.all([this.getTeamDecisions(), this.getIndividualDecisions()]);

      const hashById = (acc, item) => {
        acc[item._id] = item;
        return acc;
      };

      this.teamDecisionsById = teamDecisions.reduce(hashById, {});
      this.individualDecisionsById = individualDecisions.reduce(hashById, {});
      return teamDecisions;
    },
    display({
      name: teamDecisionName,
      branchPointRules,
      checkpointLabel = '',
      next,
      end,
      decisions,
      individualDecisions,
      updated
    }) {
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      const decisionTypes = decisions.map(d => d.type).join(', ');
      const checkpointString = checkpointLabel ? ` CHECKPOINT: ${checkpointLabel}` : '';
      const endString = end ? ' END' : '';
      const branchingDecision =
        decisions.find(({ choices, type }) => ['choice', 'survey'].includes(type) && choices.some(c => c.next));
      const nextStringTop =
        next && !end
          ? ` NEXT: ${(this.teamDecisionsById[next] || {}).name || 'BROKEN LINK'}`
          : '';
      const nextStringChoice =
        (branchPointRules && branchPointRules.length)
          ? ` (${branchPointRules.map(r =>
            (r.next
              ? ((this.teamDecisionsById[r.next] || {}).name || 'BROKEN LINK')
              : 'END'))
            .join(', ')})`
          : ((!branchingDecision || end || next)
            ? ''
            : ` (${branchingDecision.choices.map(c =>
              (c.next
                ? ((this.teamDecisionsById[c.next] || {}).name || 'BROKEN LINK')
                : (c.wrong ? 'WRONG' : 'END')))
              .join(', ')})`);
      const individualDecisionsString =
        individualDecisions.map(({ _id }) => (this.individualDecisionsById[_id] || {}).name || 'BROKEN LINK').join(', ');
      const individualDecisionsStringWithLabel =
        individualDecisionsString.length > 0 ? individualDecisionsString : 'No Minor Decisions';
      return `${teamDecisionName} ${dateString}
        ${endString}${nextStringTop}${nextStringChoice} (${decisionTypes})${checkpointString}
        (${individualDecisionsStringWithLabel})`;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/TeamDecisionsList.vue